export default __webpack_public_path__ + "static/media/FOTOS_DISCO_11.7eecacb5.jpg";